import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface SupplierFilterChipProps {
  selectedSupplier?: string
  suppliers?: PriceChangeFilterLookupItem[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const SupplierFilterChip: React.FC<SupplierFilterChipProps> = ({ selectedSupplier, onRemove, suppliers }) => {
  const supplierName = useMemo(
    () => suppliers?.find((supplier) => supplier.id === selectedSupplier)?.label ?? "",
    [selectedSupplier, suppliers]
  )

  return (
    <FilterChip
      key='pricing.supplier-filter-chip'
      data-testid='pricing.supplier-filter-chip'
      label={`Supplier: ${supplierName}`}
      onDelete={() => onRemove("supplierId", undefined)}
    />
  )
}

export default SupplierFilterChip
